<template>
    <div class="">
        <img src="/images/boshqar_banner.png" alt="boshqar_banner" class="w-screen md:w-full" style="width: 101%">

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
            <div class="">
                <div class="transform transition duration-700 hover:scale-105">
                    <img src="/images/maskGroup3.png" alt="purchase_banner" class="shadow-lg w-full">
                    <div class="text-fontColor text-xl mt-2 text-center h-16 md:h-28 mb-0 mb-md-0">
                        <template v-if="$i18n.locale === 'uz'">
                            Ishni mahsulotlar xarid qilishdan boshlang
                        </template>
                        <template v-if="$i18n.locale === 'ru'">
                            Начните работу с покупки товаров
                        </template>
                        <template v-if="$i18n.locale === 'en'">
                            Start to working by purchase products
                        </template>
                    </div>
                </div>
                <b-button class="bg-main w-11/12 md:w-full font-bold font-montserrat h-14 flex justify-center items-center mx-3 mx-md-0 py-2 rounded-lg hover:bg-hoverMain focus:ring-0" :to="$i18nHelper.getUrl('products/0/purchase')">
                    <template v-if="$i18n.locale === 'uz'">
                        Xarid qilish
                    </template>
                    <template v-if="$i18n.locale === 'ru'">
                        Покупка
                    </template>
                    <template v-if="$i18n.locale === 'en'">
                        Purchase
                    </template>
                </b-button>
            </div>
            <div class="">
                <div class="transform transition duration-700 hover:scale-105">
                    <img src="/images/Mask%20group%20(1).png" alt="sale_banner" class="rounded shadow-lg w-full">
                    <div class="text-fontColor text-xl mt-2 text-center h-16 md:h-28 mb-0 mb-md-0">
                        <template v-if="$i18n.locale === 'uz'">
                            Endi, mahsulotlaringizni sotishingiz mumkin
                        </template>
                        <template v-if="$i18n.locale === 'ru'">
                            Теперь, вы можете продавать свои товары
                        </template>
                        <template v-if="$i18n.locale === 'en'">
                            Now, you can sell your products
                        </template>
                    </div>
                </div>
                <b-button class="bg-main w-11/12 md:w-full mx-3 mx-md-0 font-bold font-montserrat h-14 flex justify-center items-center py-2 rounded-lg hover:bg-hoverMain focus:ring-0" @click="goToSaleApp">
                    <template v-if="$i18n.locale === 'uz'">
                        Savdo
                    </template>
                    <template v-if="$i18n.locale === 'ru'">
                        Продажа
                    </template>
                    <template v-if="$i18n.locale === 'en'">
                        Sale
                    </template>
                </b-button>
            </div>
            <div class="">
                <div class="transform transition duration-700 hover:scale-105">
                    <img src="/images/maskGroup1.png" alt="products_list_banner" class="rounded shadow-lg w-full border">
                    <div class="text-fontColor text-xl mt-2 text-center h-16 md:h-28 mb-0 mb-md-0">
                        <template v-if="$i18n.locale === 'uz'">
                            Sotib olingan va sotilgan mahsulotlar ro’yxatini ham ko’rishingiz mumkin
                        </template>
                        <template v-if="$i18n.locale === 'ru'">
                            Вы так же можете посмотреть список купленных и проданных товаров
                        </template>
                        <template v-if="$i18n.locale === 'en'">
                            You can also see purchased and sold products
                        </template>
                    </div>
                </div>
                <b-button class="bg-main w-11/12 md:w-full mx-3 mx-md-0 font-bold font-montserrat h-14 flex justify-center items-center py-2 rounded-lg hover:bg-hoverMain focus:ring-0" :to="$i18nHelper.getUrl('products')">
                    <template v-if="$i18n.locale === 'uz'">
                        Mahsulotlar
                    </template>
                    <template v-if="$i18n.locale === 'ru'">
                        Товары
                    </template>
                    <template v-if="$i18n.locale === 'en'">
                        Products
                    </template>
                </b-button>
            </div>
        </div>

        <div class="card my-5">
            <!--  social networks  -->
            <div class="container-fluid py-3">
                <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5">
                    <div class="mb-2">
                        <a href="https://facebook.com/boshqarCom" target="_blank" class="text-decoration-none">
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="22" cy="22" r="22" fill="#425894"/>
                                <path
                                    d="M34 22.073C34 15.4037 28.629 10 22 10C15.371 10 10 15.4037 10 22.073C10 28.0988 14.3882 33.0935 20.125 34V25.563H17.0766V22.073H20.125V19.4131C20.125 16.3875 21.9153 14.7163 24.6574 14.7163C25.9706 14.7163 27.3439 14.9519 27.3439 14.9519V17.9215H25.8303C24.34 17.9215 23.875 18.8523 23.875 19.8069V22.073H27.2031L26.6708 25.563H23.875V34C29.6118 33.0935 34 28.0988 34 22.073Z"
                                    fill="white"/>
                            </svg>
                            <span class="font-weight-bold text-dark ml-2">Facebook</span>
                        </a>
                    </div>
                    <div class="mb-2">
                        <a href="https://instagram.com/boshqarCom" target="_blank" class="text-decoration-none">
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="22" cy="22" r="22" fill="#262626"/>
                                <path
                                    d="M22.0027 15.8467C18.5974 15.8467 15.8508 18.594 15.8508 22C15.8508 25.406 18.5974 28.1533 22.0027 28.1533C25.4079 28.1533 28.1546 25.406 28.1546 22C28.1546 18.594 25.4079 15.8467 22.0027 15.8467ZM22.0027 26.0004C19.8021 26.0004 18.0031 24.2064 18.0031 22C18.0031 19.7936 19.7968 17.9996 22.0027 17.9996C24.2086 17.9996 26.0022 19.7936 26.0022 22C26.0022 24.2064 24.2032 26.0004 22.0027 26.0004ZM29.8412 15.595C29.8412 16.3929 29.1987 17.0302 28.4062 17.0302C27.6085 17.0302 26.9713 16.3876 26.9713 15.595C26.9713 14.8024 27.6138 14.1598 28.4062 14.1598C29.1987 14.1598 29.8412 14.8024 29.8412 15.595ZM33.9157 17.0517C33.8247 15.1291 33.3856 13.4261 31.9775 12.023C30.5747 10.6199 28.8721 10.1807 26.9499 10.0843C24.9689 9.97188 19.0311 9.97188 17.0501 10.0843C15.1333 10.1754 13.4307 10.6145 12.0225 12.0176C10.6144 13.4207 10.1807 15.1237 10.0843 17.0463C9.97189 19.0278 9.97189 24.9669 10.0843 26.9483C10.1753 28.8709 10.6144 30.5739 12.0225 31.977C13.4307 33.3801 15.1279 33.8193 17.0501 33.9157C19.0311 34.0281 24.9689 34.0281 26.9499 33.9157C28.8721 33.8246 30.5747 33.3855 31.9775 31.977C33.3803 30.5739 33.8193 28.8709 33.9157 26.9483C34.0281 24.9669 34.0281 19.0331 33.9157 17.0517ZM31.3564 29.0744C30.9388 30.1241 30.1303 30.9327 29.0755 31.3558C27.496 31.9824 23.7481 31.8378 22.0027 31.8378C20.2572 31.8378 16.504 31.977 14.9298 31.3558C13.8804 30.9381 13.0719 30.1294 12.649 29.0744C12.0225 27.4946 12.1671 23.7458 12.1671 22C12.1671 20.2542 12.0279 16.5001 12.649 14.9256C13.0666 13.8759 13.8751 13.0673 14.9298 12.6442C16.5093 12.0176 20.2572 12.1622 22.0027 12.1622C23.7481 12.1622 27.5014 12.023 29.0755 12.6442C30.1249 13.0619 30.9334 13.8706 31.3564 14.9256C31.9828 16.5054 31.8383 20.2542 31.8383 22C31.8383 23.7458 31.9828 27.4999 31.3564 29.0744Z"
                                    fill="white"/>
                            </svg>
                            <span class="font-weight-bold text-dark ml-2">Instagram</span>
                        </a>
                    </div>
                    <div class="mb-2">
                        <a href="https://t.me/boshqarCom" target="_blank" class="text-decoration-none">
                            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM17.5622 8.16097C17.3816 10.0585 16.6002 14.6631 16.2025 16.7884C16.0343 17.6876 15.7031 17.9892 15.3825 18.0186C14.6857 18.0828 14.1564 17.5581 13.4815 17.1157C12.4253 16.4234 11.8287 15.9924 10.8034 15.3168C9.61868 14.5361 10.3867 14.1071 11.0619 13.4055C11.2386 13.222 14.309 10.4292 14.3685 10.1759C14.3759 10.1442 14.383 10.0259 14.3126 9.96373C14.2423 9.9016 14.1389 9.92265 14.0641 9.93953C13.9582 9.9636 12.271 11.0788 9.00247 13.2851C8.5236 13.614 8.08982 13.7742 7.70114 13.7658C7.27268 13.7565 6.4485 13.5236 5.83577 13.3244C5.08427 13.0801 4.48698 12.951 4.539 12.5361C4.5661 12.32 4.86368 12.099 5.43174 11.8732C8.93 10.349 11.2627 9.34421 12.4299 8.85866C15.7624 7.47252 16.4549 7.23174 16.9062 7.22371C17.0055 7.22206 17.2275 7.24664 17.3712 7.36331C17.4668 7.44641 17.5278 7.56238 17.542 7.68827C17.5664 7.84459 17.5731 8.00314 17.5622 8.16097Z"
                                    fill="#4D9FEB"/>
                            </svg>
                            <span class="font-weight-bold text-dark ml-2">Telegram</span>
                        </a>
                    </div>
                    <div class="mb-2">
                        <a href="https://www.youtube.com/@boshqarCom" target="_blank" class="text-decoration-none">
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="22" cy="22" r="22" fill="#BC342B"/>
                                <path
                                    d="M33.4985 16.6286C33.2225 15.5939 32.4092 14.7791 31.3766 14.5025C29.505 14 22 14 22 14C22 14 14.495 14 12.6234 14.5025C11.5908 14.7791 10.7775 15.5939 10.5015 16.6286C10 18.5041 10 22.417 10 22.417C10 22.417 10 26.3299 10.5015 28.2053C10.7775 29.24 11.5908 30.0209 12.6234 30.2975C14.495 30.8 22 30.8 22 30.8C22 30.8 29.505 30.8 31.3766 30.2975C32.4092 30.0209 33.2225 29.24 33.4985 28.2053C34 26.3299 34 22.417 34 22.417C34 22.417 34 18.5041 33.4985 16.6286ZM19.5454 25.9696V18.8643L25.8181 22.4171L19.5454 25.9696Z"
                                    fill="white"/>
                            </svg>
                            <span class="font-weight-bold text-dark ml-2">Youtube</span>
                        </a>
                    </div>
                    <div class="mb-2">
                        <a href="https://play.google.com/store/apps/details?id=org.kadirov.apps.manager&hl=en&gl=US"
                           target="_blank" class="text-decoration-none">
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="22" cy="22" r="22" fill="#8300C5"/>
                                <path
                                    d="M27.0426 20.985L16.7119 10.6095L29.8558 18.1672L27.0426 20.985ZM14.0157 10C13.4072 10.3188 13 10.9002 13 11.655V32.345C13 33.0998 13.4072 33.6812 14.0157 34L26.0268 21.9977L14.0157 10ZM33.9188 20.5771L31.1617 18.9783L28.0864 22.0023L31.1617 25.0264L33.9749 23.4276C34.8175 22.7572 34.8175 21.2475 33.9188 20.5771ZM16.7119 33.3952L29.8558 25.8375L27.0426 23.0197L16.7119 33.3952Z"
                                    fill="white"/>
                            </svg>
                            <span class="font-weight-bold text-dark ml-2">PlayMarket</span>
                        </a>
                    </div>
                    <!--                <div class="col-6 col-sm-4 col-xl-2 social-network px-1 p-sm-1 p-md-2">-->
                    <!--                    <a href="#!" data-toggle="tooltip" data-placement="top" title="Tez kunda" role="button"-->
                    <!--                       class="text-decoration-none">-->
                    <!--                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                    <!--                            <circle cx="22" cy="22" r="22" fill="#D9D9D9"/>-->
                    <!--                            <path-->
                    <!--                                d="M28.184 22.6449C28.1738 20.7813 29.0168 19.3746 30.723 18.3387C29.7684 16.9727 28.3262 16.2211 26.4219 16.0738C24.6191 15.9316 22.6488 17.125 21.9277 17.125C21.166 17.125 19.4191 16.1246 18.048 16.1246C15.2145 16.1703 12.2031 18.3844 12.2031 22.8887C12.2031 24.2191 12.4469 25.5936 12.9344 27.0121C13.5844 28.8758 15.9305 33.4461 18.3781 33.3699C19.6578 33.3395 20.5617 32.4609 22.2273 32.4609C23.8422 32.4609 24.6801 33.3699 26.107 33.3699C28.575 33.3344 30.6977 29.1805 31.3172 27.3117C28.0063 25.7527 28.184 22.7414 28.184 22.6449ZM25.3098 14.3066C26.6961 12.6613 26.5691 11.1633 26.5285 10.625C25.3047 10.6961 23.8879 11.4578 23.0805 12.3973C22.1918 13.4027 21.6688 14.6469 21.7805 16.0484C23.1059 16.15 24.3145 15.4695 25.3098 14.3066Z"-->
                    <!--                                fill="black"/>-->
                    <!--                        </svg>-->
                    <!--                        <span class="font-weight-bold text-dark">PlayStore</span>-->
                    <!--                    </a>-->
                    <!--                </div>-->
                </div>
            </div>
            <!--  /social networks  -->
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import localStorageLang from "@/store/local/localStorageLang";
import store from "@/store/main";

export default {
    data() {
        return {
            appName: process.env.VUE_APP_NAME,
        }
    },
    name: "Home",
    computed: {
        ...mapGetters(['isAuthenticated'])
    },
    methods: {
        goToSaleApp() {
            if (!store.getters.isAuthenticated) {
                this.$i18nHelper.toUrl('/login')
                window.location.reload()
                return
            }

            switch (process.env.VUE_APP_BRANCH) {
                case 'master':
                    window.open(`${process.env.VUE_APP_SALE_MASTER_URL}/${localStorageLang.get()}/sale`, '_blank');
                    break
                case 'dev':
                    window.open(`${process.env.VUE_APP_SALE_DEV_URL}/${localStorageLang.get()}/sale`, '_blank');
                    break
                case 'local':
                    window.open(`${process.env.VUE_APP_SALE_LOCAL_URL}/${localStorageLang.get()}/sale`, '_blank');
                    break
            }
        }
    }
}
</script>

<style scoped>

</style>
